export const getOrdinalSuffix = (numberStr: string): string => {
  const number = parseInt(numberStr, 10)
  if (!Number.isFinite(number)) {
    return `${numberStr}th`
  }
  const lastTwoDigits = Math.abs(number) % 100
  const lastDigit = Math.abs(number) % 10
  const suffix =
    lastTwoDigits >= 11 && lastTwoDigits <= 13
      ? 'th'
      : lastDigit === 1
        ? 'st'
        : lastDigit === 2
          ? 'nd'
          : lastDigit === 3
            ? 'rd'
            : 'th'
  return numberStr + suffix
}
